import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import { ICreateFirmwareContext, CreateFirmwareContext } from '../../createFirmwareState/createFirmwareContext';
import {
	IWithAdditionalValidationContext,
	WithAdditionalValidationContext,
} from 'components/WithAdditionalValidation/withAdditionalValidationContext';
import FirmwareTypeSelect from './components/FirmwareTypeSelect';
import NameFirmwareInput from './components/NameFirmwareInput';
import VersionOfFirmwareInput from './components/VersionOfFirmwareInput';
import DescriptionInput from './components/DescriptionInput';
import FirmwareSettings from './components/FirmwareSettings';
import BtnBlock from './components/BtnBlock';
import { Form } from 'antd';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './CreationForm.module.scss';

const CreationForm: React.FC = () => {
	const { setMainFormValidationFail, additionalValidationErrors } = useContext<IWithAdditionalValidationContext>(
		WithAdditionalValidationContext,
	);

	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		setTypeSelectedFirmware,
		changeNameOfFirmware,
		changeVersionOfFirmware,
		changeDescription,
		typeSelectedFirmware,
		nameOfFirmware,
		versionOfFirmware,
		description,
		fileData,
	} = useContext<ICreateFirmwareContext>(CreateFirmwareContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ typeSelectedFirmware: typeSelectedFirmware });
		form.setFieldsValue({ nameOfFirmware: nameOfFirmware });
		form.setFieldsValue({ versionOfFirmware: versionOfFirmware });
		form.setFieldsValue({ description: description });
	}, [typeSelectedFirmware, nameOfFirmware, versionOfFirmware, description]);

	const submit = async () => {
		setMainFormValidationFail(false);
		setDataForSubmit({
			id: null,
			name: nameOfFirmware,
			description: description,
			version: versionOfFirmware,
			type: typeSelectedFirmware,
			fileId: fileData.fileId,
			fileHash: fileData.fileHash,
		});
		additionalValidationErrors.length
			? setMainFormValidationFail(true)
			: changeTypeOfModalWindow('toConfirmSubmit');
	};

	const handleFormValidationFail = () => {
		setMainFormValidationFail(true);
	};

	return (
		<div className={style.container} data-test="CreationForm">
			<div className={style.formWrapper}>
				<Form
					form={form}
					name="basic"
					onFinish={submit}
					onKeyPress={preventDefaultForEnterKey}
					onFinishFailed={handleFormValidationFail}
					layout="vertical">
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="mainInfoHeading"
							theme="secondary"
							size="l"
							weight="bold"
							display="inline"
						/>
						<FirmwareTypeSelect setTypeSelectedFirmware={setTypeSelectedFirmware} />
						<NameFirmwareInput changeNameOfFirmware={changeNameOfFirmware} />
						<VersionOfFirmwareInput changeVersionOfFirmware={changeVersionOfFirmware} />
						<DescriptionInput changeDescription={changeDescription} />
					</div>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="firmwareSettingsHeading"
							theme="secondary"
							size="l"
							weight="bold"
							display="inline"
						/>
						<Text
							className={style.requiredLabel}
							translationNameSpace="form"
							translationKey="requiredLabel"
							theme="secondary"
							size="s"
							weight="bold"
							display="inline"
						/>
						<FirmwareSettings />
					</div>
					<BtnBlock />
				</Form>
			</div>
		</div>
	);
};

export default CreationForm;
